import { isIframed } from "./iframe";
import { getCognitoToken, tokenReady } from "./cognitoTokenStore";

export const buildCognitoHeaders = async (base = {}) => {
  if (!isIframed || base.Authorization) return base;
  try {
    await tokenReady();
    const token = getCognitoToken();
    return token ? { ...base, Authorization: `Cognito ${token}` } : base;
  } catch (error) {
    console.warn("Failed to get Cognito token:", error);
    return base;
  }
};
